var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("vx-card", { staticClass: "mb-4" }, [
        _c(
          "div",
          { staticClass: "flex flex-col gap-4" },
          [
            _c("validation-observer", {
              ref: "validator",
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var valid = ref.valid
                    return [
                      _c(
                        "b-form",
                        {
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.createOrUpdate($event)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "vx-row" }, [
                            _c(
                              "div",
                              { staticClass: "vx-col w-full" },
                              [
                                _c("validation-provider", {
                                  staticClass: "flex-grow",
                                  attrs: {
                                    name: _vm.$t("newsletter.title"),
                                    rules: "required",
                                    slim: ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "newsletter_title",
                                                  label: _vm.$t(
                                                    "newsletter.title"
                                                  ),
                                                  "label-for":
                                                    "newsletter_title"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  staticClass: "required",
                                                  attrs: {
                                                    id: "newsletter_title",
                                                    state:
                                                      errors.length > 0
                                                        ? false
                                                        : null,
                                                    name: "newsletter_title"
                                                  },
                                                  model: {
                                                    value: _vm.model.title,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.model,
                                                        "title",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "model.title"
                                                  }
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger"
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          ]),
                          _c("div", { staticClass: "vx-row mb-6" }, [
                            _c(
                              "div",
                              { staticClass: "vx-col w-full" },
                              [
                                _c("select-suggestion", {
                                  attrs: {
                                    column: "company_name,trading_name,cnpj",
                                    model: "LegalEntity",
                                    label: _vm.$t("legal_entities_unit"),
                                    appendClearOption: true,
                                    placeholderText:
                                      "Digite o nome ou cnpj da pessoa jurídica",
                                    itemTextFormat:
                                      _vm.legalEntityItemTextFormat
                                  },
                                  model: {
                                    value: _vm.selectedLegalEntity,
                                    callback: function($$v) {
                                      _vm.selectedLegalEntity = $$v
                                    },
                                    expression: "selectedLegalEntity"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _c("div", { staticClass: "vx-row" }, [
                            _c(
                              "div",
                              { staticClass: "vx-col w-full sm:w-1/2" },
                              [
                                _c("validation-provider", {
                                  staticClass: "flex-grow",
                                  attrs: {
                                    name: _vm.$t("group_news.group"),
                                    rules: "required",
                                    slim: ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "flex grid-cols-2"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "w-10/12" },
                                                  [
                                                    _c("select-suggestion", {
                                                      key: _vm.groupNewsKey,
                                                      staticClass: "required",
                                                      attrs: {
                                                        column: "name",
                                                        model: "GroupNews",
                                                        label: _vm.$t(
                                                          "group_news.group"
                                                        ),
                                                        appendClearOption: true,
                                                        placeholderText:
                                                          "Digite o nome do grupo"
                                                      },
                                                      on: {
                                                        clearSelection:
                                                          _vm.clearSubgroupNews,
                                                        "selected-model":
                                                          _vm.clearSubgroupNews
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.selectedGroupNews,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.selectedGroupNews = $$v
                                                        },
                                                        expression:
                                                          "selectedGroupNews"
                                                      }
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "w-2/12 flex justify-center",
                                                    class: _vm.enableSubgroupNews
                                                      ? "items-end"
                                                      : "items-center"
                                                  },
                                                  [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "tooltip",
                                                            rawName:
                                                              "v-tooltip.top",
                                                            value: {
                                                              content:
                                                                "Adicionar um novo grupo",
                                                              delay: {
                                                                show: 100,
                                                                hide: 100
                                                              }
                                                            },
                                                            expression:
                                                              "{content: 'Adicionar um novo grupo',delay: { show: 100, hide: 100 }}",
                                                            modifiers: {
                                                              top: true
                                                            }
                                                          }
                                                        ],
                                                        attrs: {
                                                          variant:
                                                            "outline-primary",
                                                          size: "sm"
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.showAddGroupModal
                                                        }
                                                      },
                                                      [
                                                        _c("feather-icon", {
                                                          attrs: {
                                                            icon: "PlusIcon"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "vx-col w-full sm:w-1/2" },
                              [
                                _c("validation-provider", {
                                  staticClass: "flex-grow",
                                  attrs: {
                                    name: _vm.$t("subgroup_news.subgroup"),
                                    rules: "required",
                                    slim: ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "flex grid-cols-2"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "w-10/12" },
                                                  [
                                                    _c("select-suggestion", {
                                                      key: _vm.subgroupNewsKey,
                                                      staticClass: "required",
                                                      attrs: {
                                                        column: "name",
                                                        model: "SubgroupNews",
                                                        label: _vm.$t(
                                                          "subgroup_news.subgroup"
                                                        ),
                                                        appendClearOption: true,
                                                        placeholderText:
                                                          "Digite o nome do subgrupo",
                                                        disabled: !_vm.enableSubgroupNews,
                                                        extraParamsFilters: {
                                                          group_news_id: _vm.selectedGroupNews
                                                            ? _vm
                                                                .selectedGroupNews
                                                                .id
                                                            : null
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.selectedSubgroupNews,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.selectedSubgroupNews = $$v
                                                        },
                                                        expression:
                                                          "selectedSubgroupNews"
                                                      }
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "w-2/12 flex justify-center",
                                                    class:
                                                      _vm.selectedSubgroupNews &&
                                                      _vm.selectedSubgroupNews
                                                        .id
                                                        ? "items-end"
                                                        : "items-center"
                                                  },
                                                  [
                                                    _vm.enableSubgroupNews
                                                      ? _c(
                                                          "b-button",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "tooltip",
                                                                rawName:
                                                                  "v-tooltip.top",
                                                                value: {
                                                                  content:
                                                                    "Adicionar um novo subgrupo",
                                                                  delay: {
                                                                    show: 100,
                                                                    hide: 100
                                                                  }
                                                                },
                                                                expression:
                                                                  "{content: 'Adicionar um novo subgrupo',delay: { show: 100, hide: 100 }}",
                                                                modifiers: {
                                                                  top: true
                                                                }
                                                              }
                                                            ],
                                                            attrs: {
                                                              variant:
                                                                "outline-primary",
                                                              size: "sm"
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.showAddSubgroupModal
                                                            }
                                                          },
                                                          [
                                                            _c("feather-icon", {
                                                              attrs: {
                                                                icon: "PlusIcon"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          ]),
                          _c("div", { staticClass: "vx-row pt-1" }, [
                            _c(
                              "div",
                              { staticClass: "vx-col w-full" },
                              [
                                _c("validation-provider", {
                                  staticClass: "flex-grow",
                                  attrs: {
                                    name: _vm.$t("newsletter.link"),
                                    rules: "required",
                                    slim: ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "newsletter_link",
                                                  label: _vm.$t(
                                                    "newsletter.link"
                                                  ),
                                                  "label-for": "newsletter_link"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  staticClass: "required",
                                                  attrs: {
                                                    id: "newsletter_link",
                                                    state:
                                                      errors.length > 0
                                                        ? false
                                                        : null,
                                                    name: "newsletter_link"
                                                  },
                                                  model: {
                                                    value: _vm.model.link,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.model,
                                                        "link",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "model.link"
                                                  }
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger"
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "clipboard",
                                                        rawName:
                                                          "v-clipboard:copy",
                                                        value: _vm.exemploLink,
                                                        expression:
                                                          "exemploLink",
                                                        arg: "copy"
                                                      },
                                                      {
                                                        name: "clipboard",
                                                        rawName:
                                                          "v-clipboard:success",
                                                        value: function() {
                                                          _vm.notifySuccess(
                                                            _vm.$vs,
                                                            "Cópia realizada com sucesso."
                                                          )
                                                        },
                                                        expression:
                                                          "() => {notifySuccess($vs, 'Cópia realizada com sucesso.')}",
                                                        arg: "success"
                                                      },
                                                      {
                                                        name: "clipboard",
                                                        rawName:
                                                          "v-clipboard:error",
                                                        value: function() {
                                                          _vm.notifyError(
                                                            _vm.$vs,
                                                            "Não foi possível realizar a cópia."
                                                          )
                                                        },
                                                        expression:
                                                          "() => {notifyError($vs, 'Não foi possível realizar a cópia.')}",
                                                        arg: "error"
                                                      },
                                                      {
                                                        name: "tooltip",
                                                        rawName:
                                                          "v-tooltip.top",
                                                        value: {
                                                          content:
                                                            "Copiar link completo",
                                                          delay: {
                                                            show: 100,
                                                            hide: 100
                                                          }
                                                        },
                                                        expression:
                                                          "{content: 'Copiar link completo',delay: { show: 100, hide: 100 }}",
                                                        modifiers: { top: true }
                                                      }
                                                    ],
                                                    staticClass:
                                                      "align-left small w-full flex ml-1 text-break cursor-pointer pt-1 pb-2 gap-2"
                                                  },
                                                  [
                                                    _c("feather-icon", {
                                                      attrs: {
                                                        icon: "LinkIcon",
                                                        svgClasses:
                                                          "h-5 w-5 mb-1 stroke-current text-primary mr-1 align-midle"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.exemploLink
                                                        ) +
                                                        " "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          ]),
                          _c("div", { staticClass: "vx-row" }, [
                            _c(
                              "div",
                              { staticClass: "vx-col flex" },
                              [
                                _c("validation-provider", {
                                  staticClass: "flex-grow",
                                  attrs: {
                                    name: _vm.$t("newsletter.status"),
                                    rules: "required",
                                    slim: ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "newsletter.status"
                                                  ),
                                                  "label-for": "status"
                                                }
                                              },
                                              [
                                                _c(
                                                  "b-form-radio-group",
                                                  {
                                                    attrs: {
                                                      id: "status",
                                                      name: "status"
                                                    },
                                                    model: {
                                                      value: _vm.model.status,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.model,
                                                          "status",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "model.status"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b-form-radio",
                                                      {
                                                        attrs: { value: "DR" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "newsletter.status_.DR"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "b-form-radio",
                                                      {
                                                        attrs: { value: "RE" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "newsletter.status_.RE"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "vx-col flex" },
                              [
                                _c("validation-provider", {
                                  staticClass: "flex-grow",
                                  attrs: {
                                    name: _vm.$t("newsletter.allows_comment"),
                                    rules: "required",
                                    slim: ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "newsletter.allows_comment"
                                                  ),
                                                  "label-for": "allows_comment"
                                                }
                                              },
                                              [
                                                _c("b-form-checkbox", {
                                                  staticClass: "mr-n2",
                                                  attrs: {
                                                    id: "allows_comment",
                                                    name: "allows_comment",
                                                    switch: ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.model.allows_comment,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.model,
                                                        "allows_comment",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "model.allows_comment"
                                                  }
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger"
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "vx-col flex" },
                              [
                                _c("validation-provider", {
                                  staticClass: "flex-grow",
                                  attrs: {
                                    name: _vm.$t("newsletter.allows_enjoy"),
                                    rules: "required",
                                    slim: ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "newsletter.allows_enjoy"
                                                  ),
                                                  "label-for": "allows_enjoy"
                                                }
                                              },
                                              [
                                                _c("b-form-checkbox", {
                                                  staticClass: "mr-n2",
                                                  attrs: {
                                                    id: "allows_enjoy",
                                                    name: "allows_enjoy",
                                                    switch: ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.model.allows_enjoy,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.model,
                                                        "allows_enjoy",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "model.allows_enjoy"
                                                  }
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger"
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "vx-col flex" },
                              [
                                _c("validation-provider", {
                                  staticClass: "flex-grow",
                                  attrs: {
                                    name: _vm.$t("newsletter.allows_signature"),
                                    rules: "required",
                                    slim: ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "newsletter.allows_signature"
                                                  ),
                                                  "label-for": "allows_enjoy"
                                                }
                                              },
                                              [
                                                _c("b-form-checkbox", {
                                                  staticClass: "mr-n2",
                                                  attrs: {
                                                    id: "allows_signature",
                                                    name: "allows_signature",
                                                    switch: ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.model
                                                        .allows_signature,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.model,
                                                        "allows_signature",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "model.allows_signature"
                                                  }
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger"
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          ]),
                          _c("div", { staticClass: "vx-row" }, [
                            _c(
                              "div",
                              { staticClass: "vx-col w-full" },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("newsletter.content"),
                                      "label-for": "content"
                                    }
                                  },
                                  [
                                    _c("complex-editor", {
                                      attrs: { editor_data: _vm.model.content },
                                      on: {
                                        "update:editor_data": function($event) {
                                          return _vm.$set(
                                            _vm.model,
                                            "content",
                                            $event
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "w-full flex gap-2 justify-end" },
                        [
                          !_vm.isEdit()
                            ? _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "permission",
                                      rawName: "v-permission",
                                      value: "newsletters.create",
                                      expression: "'newsletters.create'"
                                    }
                                  ],
                                  attrs: {
                                    variant: "primary",
                                    disabled: !valid
                                  },
                                  on: { click: _vm.createOrUpdate }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("action.save")) + " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.isEdit()
                            ? _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "permission",
                                      rawName: "v-permission",
                                      value: "newsletters.edit",
                                      expression: "'newsletters.edit'"
                                    }
                                  ],
                                  attrs: {
                                    variant: "primary",
                                    disabled: !valid
                                  },
                                  on: { click: _vm.createOrUpdate }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("action.save")) + " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "b-button",
                            {
                              staticClass: "float-right",
                              attrs: { variant: "outline-secondary" },
                              on: { click: _vm.goBack }
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "CornerUpLeftIcon" }
                              }),
                              _c("span", { staticClass: "align-middle" }, [
                                _vm._v(_vm._s(_vm.$t("back")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ]),
      _c(
        "b-modal",
        {
          ref: "addSubgroupModal",
          attrs: {
            title: "Adicionar subgrupo",
            "hide-footer": "",
            centered: ""
          }
        },
        [
          _c("b-form-input", {
            attrs: { placeholder: "Digite o nome do subgrupo" },
            model: {
              value: _vm.newSubgroupName,
              callback: function($$v) {
                _vm.newSubgroupName = $$v
              },
              expression: "newSubgroupName"
            }
          }),
          _c(
            "div",
            { staticClass: "w-full flex gap-2 justify-end pt-4" },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary" },
                  on: { click: _vm.addSubgroup }
                },
                [_vm._v(" " + _vm._s(_vm.$t("action.save")) + " ")]
              ),
              _c(
                "b-button",
                {
                  attrs: { variant: "outline-secondary" },
                  on: { click: _vm.closeAddSubgroupModal }
                },
                [_vm._v(" " + _vm._s(_vm.$t("action.cancel")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "addGroupModal",
          attrs: { title: "Adicionar grupo", "hide-footer": "", centered: "" }
        },
        [
          _c("b-form-input", {
            attrs: { placeholder: "Digite o nome do grupo" },
            model: {
              value: _vm.newGroupName,
              callback: function($$v) {
                _vm.newGroupName = $$v
              },
              expression: "newGroupName"
            }
          }),
          _c(
            "div",
            { staticClass: "w-full flex gap-2 justify-end pt-4" },
            [
              _c(
                "b-button",
                { attrs: { variant: "primary" }, on: { click: _vm.addGroup } },
                [_vm._v(" " + _vm._s(_vm.$t("action.save")) + " ")]
              ),
              _c(
                "b-button",
                {
                  attrs: { variant: "outline-secondary" },
                  on: { click: _vm.closeAddGroupModal }
                },
                [_vm._v(" " + _vm._s(_vm.$t("action.cancel")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }